import React, { useState } from 'react';
import { Alert, Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConfigInstanceService from '../../services/configInstance.service';
import useReportPrivacy, { REPORT_PRIVACY_CHANGED } from '../../hooks/useReportPrivacy';

export default function ReportPrivacyToggle() {
  const { t } = useTranslation();
  const privacy = useReportPrivacy();
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);
  const save = async (_event: unknown, hidden: boolean) => {
    setSaving(true);
    setFailed(false);
    try {
      const response = await new ConfigInstanceService().updateReportPrivacy(hidden);
      if (!response?.data?.success || typeof response.data.data?.hideUserInfoInReports !== 'boolean') {
        throw new Error('Privacy update failed');
      }
      window.dispatchEvent(new CustomEvent(REPORT_PRIVACY_CHANGED, {
        detail: response.data.data.hideUserInfoInReports,
      }));
    } catch {
      setFailed(true);
    } finally {
      setSaving(false);
    }
  };
  return <Box sx={{ px: 2, py: 1, maxWidth: 380 }}>
    <FormControlLabel label={t('configuration.report_privacy_label')}
      control={<Switch checked={privacy.hidden} disabled={saving || !privacy.ready} onChange={save} />} />
    <Typography variant="body2" color="text.secondary">{t('configuration.report_privacy_help')}</Typography>
    {(failed || privacy.error) && <Alert severity="error">{t('configuration.report_privacy_error')}</Alert>}
  </Box>;
}
